import React from "react";
import ContentAgendaSection from "./ContentAgendaSection";
import HeroSectionConclave from "./HeroSectionAgenda";
import ConclaveFooter from "./ConclaveFooter";

function AgendaPage(props) {
  return (
    <>
      <HeroSectionConclave />
      <ContentAgendaSection />
      <ConclaveFooter />
    </>
  );
}

export default AgendaPage;
